export enum RequestRegistrationFilterComponentTypeEnum {
    intArray = 1,
    decimal = 2,
    int = 3,
    stringArray = 4,
}